import { getRequest, postRequest, getcontractIdNumber } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm = searchTerm || '%20';
  orderBy = orderBy || '%20';
  if (!searchTerm.includes('ContractID'))
    searchTerm = `${searchTerm}, ContractID:${getcontractIdNumber()},`
  return getRequest(
    `technicianPart/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy ||
      '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`technicianPart/edit/${id}`)
}

export async function save(values) {
  return postRequest(`technicianPart/save`, values)
}

export function remove(values) {
  return postRequest(`technicianPart/delete`, values)
}

export async function list2(size, index, searchTerm, orderBy, partID, technicianID) {
  const contractID = getcontractIdNumber()
  const url = `technicianPart/get-list2/${parseInt(size, 10) || 15}/${parseInt(index, 10) || 0}/${searchTerm ||
    '%20'}/${orderBy || '%20'}/${contractID}/${partID || '%20'}/${technicianID || '%20'}`
  return getRequest(url)
}
